import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, createSlots as _createSlots, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b1b247e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "carousel__item" }
const _hoisted_2 = { class: "carousel__item" }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["onClick"]

import { computed, getCurrentInstance, onMounted, Ref, ref, watch } from 'vue';
import 'vue3-carousel/dist/carousel.css';
import { useAppStore } from '@/store/modules/app';
import { Carousel, Navigation, Slide } from 'vue3-carousel';
import { ComponentInternalInstance } from '@vue/runtime-core';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseImageCarousel',
  props: {
    slides: {},
    itemsToShow: {},
    showNavigation: { type: Boolean, default: true },
    thumbnailsNavigation: { type: Boolean, default: false },
    withBgColor: { type: Boolean },
    withPreview: { type: Boolean, default: true },
    widthSmallItem: { default: 120 },
    carouselGap: { default: '5' }
  },
  setup(__props: any) {

const window = computed((): number => {
  return useAppStore().window;
});

const instance: ComponentInternalInstance | null = getCurrentInstance();
const uuid = ref(instance?.uid);

const props = __props;

const currentSlide = ref(0);
const next = () => {
  currentSlide.value = currentSlide.value + 1;
};
const prev = () => {
  currentSlide.value = currentSlide.value - 1;
};

// const thumbnails = ref<HTMLElement | undefined>();
const galleryWidth: Ref<number | undefined> = ref(undefined);
const maxItemsToShow: Ref<number> = ref(1);

const updateGalleryWidth = () => {
  if (props.slides.length > 1) {
    const thumbnails = document.getElementById(`thumbnails${uuid.value}`);

    galleryWidth.value = thumbnails?.offsetWidth;
    updateMaxItemsToShow();
  }
};

const updateMaxItemsToShow = () => {
  if (galleryWidth.value) {
    maxItemsToShow.value = Math.round(galleryWidth.value / props.widthSmallItem);
  } else {
    updateGalleryWidth();
  }
};

const cssProps = computed(() => {
  return {
    '--carousel-gap': props.carouselGap + 'px' ?? '5px',
  };
});

const slideTo = (val: number) => {
  currentSlide.value = val;
};

onMounted(() => {
  if (props.itemsToShow) {
    maxItemsToShow.value = props.itemsToShow;
  } else {
    updateGalleryWidth();
  }
});
watch(
  () => window.value,
  () => {
    if (!props.itemsToShow) {
      updateGalleryWidth();
    }
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "carousel",
    style: _normalizeStyle([cssProps.value]),
    class: "carousel-box"
  }, [
    (_ctx.slides.length === 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({ withBgColor: _ctx.withBgColor })
        }, [
          _createVNode(_unref(Slide), null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "item", {
                  data: _ctx.slides[0]
                })
              ])
            ]),
            _: 3
          })
        ], 2))
      : (_ctx.withPreview)
        ? (_openBlock(), _createBlock(_unref(Carousel), {
            key: 1,
            id: "gallery",
            modelValue: currentSlide.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentSlide).value = $event)),
            class: _normalizeClass({ withBgColor: _ctx.withBgColor }),
            "items-to-show": 1,
            "wrap-around": true
          }, _createSlots({
            default: _withCtx(() => [
              _createTextVNode("class=\"carousel__item\" "),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, i) => {
                return (_openBlock(), _createBlock(_unref(Slide), { key: i }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _renderSlot(_ctx.$slots, "item", { data: slide })
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 2
          }, [
            (_ctx.showNavigation && _ctx.slides.length > 1)
              ? {
                  name: "addons",
                  fn: _withCtx(() => [
                    _createVNode(_unref(Navigation))
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "class"]))
        : _createCommentVNode("", true),
    (_ctx.slides.length > 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass({ 'carousel-box--with-navigation': _ctx.thumbnailsNavigation })
        }, [
          (_ctx.thumbnailsNavigation)
            ? (_openBlock(), _createBlock(_component_base_icon, {
                key: 0,
                disabled: currentSlide.value === 0,
                class: "arrow_back",
                clickable: "",
                color: "#868298",
                height: "14",
                name: "arrow_back_ios",
                width: "15",
                onClick: prev
              }, null, 8, ["disabled"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            id: `thumbnails${uuid.value}`,
            ref: "thumbnails",
            class: "carousel__thumbnails"
          }, [
            _createVNode(_unref(Carousel), {
              id: "thumbnails",
              modelValue: currentSlide.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentSlide).value = $event)),
              "items-to-show": _ctx.slides.length > maxItemsToShow.value ? maxItemsToShow.value : _ctx.slides.length,
              "wrap-around": false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, i) => {
                  return (_openBlock(), _createBlock(_unref(Slide), { key: i }, {
                    default: _withCtx(() => [
                      (_ctx.withPreview)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "carousel__small-item pointer",
                            onClick: ($event: any) => (slideTo(i))
                          }, [
                            _renderSlot(_ctx.$slots, "smallItem", { data: slide })
                          ], 8, _hoisted_4))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: _normalizeStyle({ width: _ctx.widthSmallItem }),
                            class: "carousel__small-item"
                          }, [
                            _renderSlot(_ctx.$slots, "smallItem", { data: slide })
                          ], 4))
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 3
            }, 8, ["modelValue", "items-to-show"])
          ], 8, _hoisted_3),
          (_ctx.thumbnailsNavigation)
            ? (_openBlock(), _createBlock(_component_base_icon, {
                key: 1,
                disabled: currentSlide.value === _ctx.slides.length - 1,
                class: "arrow_forward",
                clickable: "",
                color: "#868298",
                height: "14",
                name: "arrow_forward_ios",
                width: "15",
                onClick: next
              }, null, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 4))
}
}

})